"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisableDiv = exports.MaskInputStyled = exports.CheckboxStyled = exports.FormItemFormulary = exports.RadioStyled = exports.CustomSVG = exports.InputStyled = exports.SubTitle = exports.DividerTitle = exports.ContainerPayment = exports.ContainerBody = void 0;
const antd_1 = require("antd");
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const Checkbox_1 = __importDefault(require("antd/lib/checkbox/Checkbox"));
const styled_components_1 = __importStar(require("styled-components"));
exports.ContainerBody = styled_components_1.default.div `
  width: 100%;
  min-height: 100vh;
  height: auto;
  font-size: 1em;
  padding: 0 32px;
  button {
    width: 100%;
    height: 43px;
    border-radius: 5px;
    text-align: left;
  }
  ${(props) => props.disabled === true &&
    (0, styled_components_1.css) `
      display: none;
    `};
  @media screen and (max-width: 992px) {
    padding: 0px 0px;
    .divisor {
      display: none !important;
    }
  }
`;
exports.ContainerPayment = styled_components_1.default.div `
  ${(props) => props.disabled === true &&
    (0, styled_components_1.css) `
      display: none;
    `};
`;
exports.DividerTitle = (0, styled_components_1.default)(antd_1.Divider) `
  margin: 10px 0 !important;
  &::before {
    display: none;
  }
  & > span {
    font-size: 1.8em;
    padding-left: 0px !important;
  }
`;
exports.SubTitle = (0, styled_components_1.default)(antd_1.Typography.Title) `
  color: var(--main-color) !important;
  margin-bottom: 15px;
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  border-radius: 5px;
  height: 43px;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
`;
exports.CustomSVG = styled_components_1.default.img.attrs((props) => ({
    src: props.svg,
})) `
  width: 25px;
  height: 25px;
  margin-right: 15px;
`;
exports.RadioStyled = (0, styled_components_1.default)(antd_1.Radio) `
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  margin-right: 25px;
`;
exports.FormItemFormulary = (0, styled_components_1.default)(antd_1.Form.Item) `
  label {
    color: #000;
    font-weight: 500;
  }
`;
exports.CheckboxStyled = (0, styled_components_1.default)(Checkbox_1.default) `
  display: flex;
  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
  }
  a {
    color: #000;
    text-decoration: underline;
  }
`;
exports.MaskInputStyled = (0, styled_components_1.default)(antd_mask_input_1.default) `
  border-radius: 5px;
  height: 43px;
`;
exports.DisableDiv = styled_components_1.default.div `
  pointer-events: none;
  opacity: 0.4;
  transition: opacity 0.5s;
  ${props => props.disabled === false &&
    (0, styled_components_1.css) `
      pointer-events: all;
      opacity: 1;
    `}
`;
